import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from '../../../utils/grid/Grid';
import BookingSidebar from '../../../components/bookingSidebar/BookingSidebar';

const BookingLayout = (props) => (
  <Grid className="booking">
    <Row>
      <BookingSidebar show="xs sm" {...props} />
      <Col xs={12} md={8} className="booking-content">
        {props.children}
      </Col>
      <BookingSidebar show="md lg xl" {...props} />
    </Row>
  </Grid>
);

BookingLayout.propTypes = {
  ...BookingSidebar.propTypes,
  children: PropTypes.node,
};

export default BookingLayout;
